/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useState, useRef, useEffect } from 'react'
import clsx from 'clsx'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { setLanguage, useLang } from '../../../../_metronic/i18n/Metronici18n'
import { Tr } from '../../../../_metronic/i18n/Tr'

const languages = [
    {
        lang: 'uz',
        name: 'O’zbekcha',
        flag: toAbsoluteUrl('/media/flags/uzbekistan.svg'),
    },
    {
        lang: 'ru',
        name: 'Русский',
        flag: toAbsoluteUrl('/media/flags/russia.svg'),
    },
    {
        lang: 'en',
        name: 'English',
        flag: toAbsoluteUrl('/media/flags/united-states.svg'),
    },
]

const LanguageDropdown: FC = () => {
    const lang = useLang()
    const t = Tr()
    const currentLanguage = languages.find((x) => x.lang === lang)
    const [open, setOpen] = useState(false)
    const dropdownRef = useRef<HTMLDivElement | null>(null)

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setOpen(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    return (
        <div className='position-relative' ref={dropdownRef}>
            <button
                type='button'
                onClick={() => setOpen(!open)}
                className='btn btn-light d-flex align-items-center px-3 py-2 rounded shadow-sm'
            >
                {t('Language')}: <span className='mx-2 fw-semibold'>{currentLanguage?.name}</span>
                <img
                    className='w-20px h-20px rounded-1'
                    src={currentLanguage?.flag}
                    alt='language'
                />
            </button>

            {open && (
                <div
                    className='dropdown-menu show mt-2 p-2 shadow-sm rounded'
                    style={{ position: 'absolute', right: 0, minWidth: '175px', zIndex: 1000 }}
                >
                    {languages.map((l) => (
                        <button
                            key={l.lang}
                            onClick={() => {
                                setLanguage(l.lang)
                                setOpen(false)
                            }}
                            className={clsx(
                                'dropdown-item d-flex align-items-center',
                                { active: l.lang === currentLanguage?.lang }
                            )}
                        >
                            <img className='w-20px h-20px rounded-1 me-3' src={l.flag} alt={l.name} />
                            {l.name}
                        </button>
                    ))}
                </div>
            )}
        </div>
    )
}

export { LanguageDropdown }
